// src/pages/parts/GroupList.js
import React from 'react';
// CSS is imported in the parent page (Groups.js), so classes are available here.

const GroupList = ({ groups, selectedGroupId, onSelect }) => {
  return (
    <div className="group-list-container">
      <div className="group-list-header">
        <h3 className="group-list-title">Available Groups</h3>
      </div>
      
      <ul className="group-list-ul">
        {groups.map((group) => {
          const isActive = group.id === selectedGroupId;
          
          return (
            <li 
              key={group.id} 
              className={`group-list-item ${isActive ? 'active' : ''}`}
              onClick={() => onSelect(group)}
            >
              <span className="group-list-icon">{group.icon}</span>
              <span className="group-list-name">{group.name}</span>
              
              {/* Optional: Small arrow indicator for active item */}
              <span className="group-list-arrow">▶</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default GroupList;
